(function ($, Drupal, once) {
  Drupal.behaviors.veoliaPageLoading = {
    // eslint-disable-next-line object-shorthand
    attach: function () {
      const $body = $('body');
      // Show the spinner after a delay.
      if (!$body.hasClass('show-loader-icon')) {
        setTimeout(function () {
          $body.addClass('show-loader-icon');
        }, 1000);
      }
      if ($('span[data-big-pipe-placeholder-id]').length === 0) {
        setTimeout(function () {
          $body.addClass('loaded');
        }, 100);
      } else {
        $(once('page-load', 'body:not(.loaded)')).each(function () {
          // Backstop in case of big pipe failure.
          setTimeout(function () {
            $body.addClass('loaded');
            Drupal.ajax.bindAjaxLinks($body.get(0));
          }, 5000);
        });
      }
    },
  };
}(jQuery, Drupal, once));
